<template>
  <div>
    <!--检索-->
    <el-row>
      <el-col>
        <el-form :inline="true" :model="requestData" label-width="120px" style="text-align: right">
          <el-form-item>
            <el-input clearable size="medium" :placeholder="placeholder" v-model="searchText">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!--表格数据-->
    <el-table v-if="tableData" :data="tableData" stripe style="width: 100%; margin-top: 20px;">
      <el-table-column label="名称">
        <template slot-scope="scope">
          {{scope.row[titleField]}}
        </template>

      </el-table-column>

      <el-table-column width="100" label="价格">
        <template slot-scope="scope">
          {{scope.row[priceField]}}
        </template>
      </el-table-column>

      <el-table-column prop="status" width="100" align="center" label="活动状态">
        <template slot-scope="scope">
          {{formatActivityStatus(scope.row[activityStatusField])}}
        </template>
      </el-table-column>

      <el-table-column prop="" label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="select(scope.row, idList.indexOf(scope.row.id))" v-text="idList.indexOf(scope.row.id) !== -1 ? '已选取' : '选取'"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tableData" class="pagination-wrapper">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="requestData.count" layout="total, prev, pager, next" :total="totalNumber">
      </el-pagination>
    </div>
    <el-row type="flex" justify="center">
      <div class="bottom-btn-box">
        <el-button class="btn-long" type="primary" @click="closeDialog">关闭</el-button>
      </div>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import Util from "@/js/util";

export default {
  props: {
    // 请求的URL
    url: {
      default: "",
      type: String
    },
    // 默认请求参数
    params: {
      default: function() {
        return { status: 1 };
      },
      type: Object
    },
    // 名称搜索字段
    searchField: {
      default: "name_like",
      type: String
    },
    // placeholder
    placeholder: {
      default: "根据名称进行搜索",
      type: String
    },
    // 价格字段
    priceField: {
      default: "promotion_price",
      type: String
    },
    // 标题字段
    titleField: {
      default: "name",
      type: String
    },
    // 活动状态字段
    activityStatusField: {
      default: "activity_status",
      type: String
    },
    // 服务端返回的数组名称
    resultArrayName: {
      default: "item_list",
      type: String
    },
    // 分页数量
    count: {
      default: 20,
      type: Number
    },
    // 是否支持多选
    multi: {
      type: Boolean,
      default: false
    },
    // 已选中的idlist
    idList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      searchText: "",
      // 表格数据 & 翻页
      tableData: null,
      totalNumber: null,
      currentPage: 1,

      requestData: {
        // 翻页参数
        offset: 0,
        count: 20
      },
      selectOptions: {
        status: [{ value: 1, text: "上架" }, { value: 2, text: "下架" }],
        activityStatus: [
          { value: 1, text: "未开始" },
          { value: 2, text: "进行中" },
          { value: 3, text: "已结束" },
          { value: 4, text: "已结束" }
        ]
      }
    };
  },
  watch: {
    url(val) {
      this.searchText = "";
      Object.assign(this.requestData, this.params);
      this.request();
    },
    params(val) {
      this.searchText = "";
      Object.assign(this.requestData, this.params);
      this.request();
    }
  },
  created() {
    this.requestData.count = this.count;
    this.request();
  },
  methods: {
    request() {
      // 有搜索字段时才设置搜索信息
      if (this.searchField) {
        this.requestData[this.searchField] = this.searchText;
      } else {
        delete this.requestData[this.searchField];
      }
      Object.assign(this.requestData, this.params);
      lib.api.get({
        api: this.url,
        data: this.requestData,
        success: data => {
          data.data[this.resultArrayName].map(val => {
            val[this.priceField] = Util.filterPrice(val[this.priceField]);
          });
          this.tableData = data.data[this.resultArrayName];
          this.totalNumber = data.data.total_count;
        },
        error: data => {
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {}
      });
    },
    search() {
      this.request();
    },
    select(row, index) {
      if (this.multi) {
        if (index === -1) {
          if (this.idList.length === 20) {
            this.$message.error("最多添加20个!");
            return;
          }
          this.$emit("select", row);
        } else {
          this.$emit("unSelect", row, index);
        }
      } else {
        this.$emit("select", row);
      }
    },
    formatActivityStatus(val) {
      let text = '';
      this.selectOptions.activityStatus.forEach((item) => {
        if(item.value === val){
          text = item.text;
        }
      })
      return text;
    },
    handleCurrentChange(val) {
      this.requestData.offset = this.requestData.count * (val - 1) || 0;
      this.request();
    },
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="sass">
</style>